{
  "enum": {
    "IxmAgentauthV1AgentKeyStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxmAgentauthV1AgentKeyQueryServiceAgentKeyListFilterableFields": {
      "agentId": "Agent",
      "data": {
        "userId": "User ID"
      },
      "status": "Status",
      "tenantId": "Tenant",
      "tenantType": "Tenant Type"
    }
  },
  "oneOf": {
    "IxmAgentauthV1AgentKeyEventType": {
      "archived": "Archived",
      "created": "Created",
      "keyUsed": "Key Used",
      "updated": "Updated"
    },
    "IxmAgentauthV1Grant": {
      "authorizationCode": "Authorization Code",
      "refreshToken": "Refresh Token",
      "tokenExchange": "Token Exchange"
    }
  },
  "sortEnum": {
    "IxmAgentauthV1AgentKeyQueryServiceAgentKeyListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}